export default "__VITE_ASSET__bd223352__"